import {
  ApiResponseError,
  ApiSessionTimeoutError,
  classifyApiError,
  unwrapResponseModel
} from '../api/responseModel';
import { serializeDateForApi, parseDate } from '../dates/dateService';

export {
  ApiResponseError as HistoriaAcademicaApiError,
  ApiSessionTimeoutError as HistoriaAcademicaSessionTimeoutError,
  classifyApiError as classifyHistoriaAcademicaError,
  unwrapResponseModel
};

export const RESULTADO_CURSADA_OPTIONS = [
  { value: 'R', label: 'Regular' },
  { value: 'L', label: 'Libre' },
  { value: 'P', label: 'Promoción' },
  { value: 'E', label: 'Equivalencia' }
];

export function toUpdateHistoriaAcademicaCursadaPayload({
  id,
  resultado,
  fecha,
  fechaFinRegularidad,
  observaciones
}) {
  return {
    HistoriaAcademicaCursadaCod: parseInt(id, 10),
    HistoriaAcademicaResultado: resultado,
    HistoriaAcademicaFechaFinRegul: serializeDateForApi(fechaFinRegularidad),
    HistoriaAcademicaCursadaObserv: observaciones,
    HistoriaAcademicaFecha: serializeDateForApi(fecha)
  };
}

export function toUpdateHistoriaAcademicaExamenPayload({
  id,
  resultado,
  nota,
  fechaExamen
}) {
  return {
    HistoriaAcademicaExamenCod: parseInt(id, 10),
    HistoriaAcademicaResultado: resultado,
    HistoriaAcademicaExamenNota: nota,
    HistoriaAcademicaFechaExamen: serializeDateForApi(fechaExamen)
  };
}

export function computeExamenResultadoFromNota(nota) {
  if (nota === '0' || nota === 0) {
    return 'Ausente';
  }
  return Number(nota) >= 4 ? 'Aprobó' : 'Reprobó';
}

export const EXAMEN_NOTA_OPTIONS = [
  { value: '0', label: 'Ausente' },
  { value: '1', label: '1' },
  { value: '2', label: '2' },
  { value: '3', label: '3' },
  { value: '4', label: '4' },
  { value: '5', label: '5' },
  { value: '6', label: '6' },
  { value: '7', label: '7' },
  { value: '8', label: '8' },
  { value: '9', label: '9' },
  { value: '10', label: '10' }
];

export function formatHistoriaExamenNotaDisplay(nota, resultado) {
  if (nota === null || nota === undefined || nota === '') {
    return '-';
  }
  const value = Number(nota);
  const normalizedResultado = String(resultado ?? '').trim().toLowerCase();
  if (value === 0 && normalizedResultado.includes('ausente')) {
    return ' ';
  }
  if (value === 0) {
    return '-';
  }
  return String(value);
}

export function formatHistoriaExamenResultadoDisplay(resultado) {
  const raw = String(resultado ?? '').trim();
  if (!raw) {
    return 'Sin resultados';
  }
  return raw;
}

export function formatHistoriaExamenNotaDetailDisplay(nota) {
  const value = Number(nota);
  if (value === 0) {
    return ' ';
  }
  if (value >= 1 && value <= 10) {
    const words = ['uno', 'dos', 'tres', 'cuatro', 'cinco', 'seis', 'siete', 'ocho', 'nueve', 'diez'];
    return `${value} (${words[value - 1]})`;
  }
  return '';
}

export function validateUpdateHistoriaAcademicaExamenForm({ fecha, nota }) {
  if (!fecha) {
    return {
      valid: false,
      message: 'La fecha de examen es obligatoria.'
    };
  }
  if (String(nota ?? '').trim() === '') {
    return {
      valid: false,
      message: 'La nota es obligatoria.'
    };
  }
  return { valid: true, message: '' };
}

export function validateActualizarRegularidadesForm({ carreraCodigo }) {
  return Boolean(carreraCodigo && String(carreraCodigo).length > 0);
}

export function validateUpdateHistoriaAcademicaCursadaForm({
  resultado,
  fecha,
  fechaFinRegularidad
}) {
  if (!fecha) {
    return {
      valid: false,
      message: 'La fecha de cursada es obligatoria.'
    };
  }

  if (hasFechaFinRegularidad(resultado) && isSentinelRegularidadDate(fechaFinRegularidad)) {
    return {
      valid: false,
      message: 'La fecha de fin de regularidad es obligatoria.'
    };
  }

  return { valid: true, message: '' };
}

export function normalizeResultadoCursada(resultado) {
  const value = String(resultado ?? '').trim();
  if (value === 'Equivalencia') return 'E';
  if (value === 'Regular') return 'R';
  if (value === 'Libre') return 'L';
  if (value === 'Promoción' || value === 'Promocion') return 'P';
  return value;
}

export function hasFechaFinRegularidad(resultado) {
  const code = normalizeResultadoCursada(resultado);
  return code === 'R' || code === 'P' || code === 'E';
}

export function getResultadoCursadaLabel(resultado) {
  const code = normalizeResultadoCursada(resultado);
  if (code === 'R') return 'Regular';
  if (code === 'L') return 'Libre';
  if (code === 'P') return 'Promoción';
  if (code === 'E') return 'Equivalencia';
  return code;
}

export function isSentinelRegularidadDate(dateValue) {
  if (!dateValue) {
    return true;
  }
  const raw = String(dateValue).trim();
  if (raw.startsWith('1753-')) {
    return true;
  }
  const parsed = parseDate(raw);
  return parsed != null && parsed.getFullYear() <= 1753;
}
